import { useSearch } from '@tanstack/react-router'

/**
 * The notice a dead sign-in link lands under (AuthController::INVALID_LINK_PATH
 * redirects with ?auth=invalid_link).
 *
 * Reads the flag itself rather than taking a prop, because the invariant is
 * "both doors show the same notice under the same condition" — leaving the
 * condition to callers would guarantee only half of it. Renders nothing when
 * the flag is absent, so a screen can drop it in unconditionally.
 *
 * Sits ABOVE the card, not inside it: the point is to stand directly over the
 * form that can issue a fresh link. `max-w-[440px]` is JoinCard's width, so the
 * two align.
 */
export function ExpiredLinkNotice() {
  const search = useSearch({ strict: false }) as { auth?: string }
  if (search?.auth !== 'invalid_link') return null

  return (
    <p
      role="alert"
      className="mx-auto mb-6 max-w-[440px] rounded-club border border-flag/40 bg-flag/8 px-4 py-3 text-center text-[13.5px] text-flag"
    >
      That sign-in link has expired or been used. Ask for another below.
    </p>
  )
}
